import { Constants } from "@socialcoach/services";
import axios from "./AxiosClient";
import { Coach, Player } from "./dtos";

const PW_LINK_SERVICE = `${Constants.API_URL}/bedrock/admin/password_links`;
const STORAGE_FILES_SERVICE = `${Constants.API_URL}/bedrock/admin/storage_files`;

export interface PWLinkResponse {
  link: string;
}

export interface PWIntentResponse {
  status: string;
  error?: string;
}

export interface StorageFile {
  path: string;
  name: string;
  category: string;
  fileType: string;
  contentType: string | null;
  size: number;
  uploadedAt: string | null;
  url: string | null;
}

export interface StorageFilesResponse {
  coach: Coach | null;
  player: Player | null;
  files: StorageFile[];
}

export class AdminServices {
  static async registerPasswordLinkIntent(email: string): Promise<PWIntentResponse> {
    const { data } = await axios.post<PWIntentResponse>(`${PW_LINK_SERVICE}/register_intent`, { email });
    return data as PWIntentResponse;
  }

  static async getStorageFiles(userId: number): Promise<StorageFilesResponse> {
    const { data } = await axios.get<StorageFilesResponse>(STORAGE_FILES_SERVICE, { params: { userId } });
    return data;
  }

  static async verifyPasswordLinkIntent(email: string, token: string): Promise<PWLinkResponse> {
    const { data } = await axios.post<PWLinkResponse>(`${PW_LINK_SERVICE}/verify_intent`, { email, token });
    return data as PWLinkResponse;
  }
}
